import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";

@Component({
  selector: "app-landing-1-scroll-top",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule],
  templateUrl: "./landing-1-scroll-top.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1ScrollTopComponent {
  readonly visible = input(false);
  readonly scrollTop = output<void>();
}
